// extracted by mini-css-extract-plugin
export default {"hunt-plan":"HuntingPlan_hunt-plan__dJ88w","section-title":"HuntingPlan_section-title__DKCJh","container":"HuntingPlan_container__CmDA9","warning":"HuntingPlan_warning__GOSfg"};